import React, { useEffect } from 'react'
import styles from './spinner.module.scss'
import Lottie from 'react-lottie'
import animationData from 'src/assets/lotties/spinner.json'

const PageSpinner = React.memo(function PageSpinner() {
  useEffect((): any => {
    scrollTo(0, 0)
  }, [])

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <Lottie
          options={defaultOptions}
          height={58.91}
          width={54}
        />
      </div>
    </div>
  )
})

export default PageSpinner